import React from "react";

const ConfirmModal = ({ open, storeName, phoneNumber, onBack, onConfirm }) => {
  if (!open) return null;
  const formattedNumber = phoneNumber
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-xl w-[90vw] max-w-sm gap-6 px-2 py-6 relative flex flex-col justify-between min-h-[80vh]">
        <div className="flex justify-center mb-6 mt-12">
          <img
            src="/assets/send.png"
            alt="전화 아이콘"
            className="w-[16vw] max-w-[60px] h-auto"
          />
        </div>

        <div className="flex flex-col items-center">
          <div className="text-sm font-medium text-black">{storeName}</div>
          <div className="text-[1.4rem] font-bold mt-1">
            “{formattedNumber}”
          </div>
        </div>

        {/* 설명 */}
        <div className="flex flex-col items-center text-[4vw] font-semibold leading-relaxed">
          <div>
            해당 번호로
            <span className="font-bold"> 매일 저녁 9시 30분에</span>
          </div>
          <div>매출 분석 리포트가 발송될 예정입니다.</div>
          <br />
          등록하시겠습니까?
        </div>

        {/* 버튼 */}
        <div className="w-full flex justify-between text-[5vw] mt-auto">
          <button
            onClick={onBack}
            className="flex-1 text-neutral-500 text-center font-bold"
          >
            이전
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 text-blue-600 text-center font-bold"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
